import { APIENV, APIS_ENUM } from '@europrocurement/l2d-domain';

import {
    PanierPaiementApi,
    Configuration,
} from '@europrocurement/l2d-domain/openApi/ApiFacturation';

export const usePaiementApi = function () {
    const env = (() => {
        if (typeof window === 'undefined' || !window.location) return 'prod';
        const href = window.location.href.toLowerCase();
        if (href.includes('localhost')) return 'local';
        if (/\bpreprod\b/.test(href)) return 'preprod';
        if (/\bqual\b/.test(href)) return 'qual';
        if (/\bdev\b/.test(href)) return 'dev';
        return 'prod';
    })();
    // const env ='qual';
    // const env ='dev';
    // const env ='preprod';
    // const env ='prod';
    // const env ='local';

    if (env === 'local') {
        console.log('api paiement param sur local, à modifier dans usePaiementApi.ts au besoin');
    }

    const facturationConfiguration = new Configuration({
        basePath: APIENV.apis[APIS_ENUM.FACTURATION][env],
    });

    const panierPaiementApi = new PanierPaiementApi(facturationConfiguration);

    return { panierPaiementApi, env };
};
export default usePaiementApi;
